<template>
    <div class="receive-container" >
        <div class="redpacket" v-if="receiveObj" :class="{'expired-container':!isExpired}">
            <div class="tenant-name">
                <p class="txt">{{receiveObj.tenantName||'　'}}</p>
                <p class="desc">{{isExpired?receiveObj.hasPicked == 0?'送你一张优惠券':'你已经领取过，快去使用吧！':'优惠券已过期！'}}</p>
            </div>
            <div class="coupon-info flexC">
                <div class="left flexC">
                    <p><span class="unit">¥</span>{{receiveObj.discount||0}}</p>
                </div>
                <div class="line"></div>
                <div class="right">
                    <p class="coupon-name">{{receiveObj.name}}</p>
                    <p class="coupon-desc">
                        {{receiveObj.thresholdType == 162002?'满'+receiveObj.thresholdMoney+'元可用':$t("shop.noSill")}}
                    </p>
                </div>
                <p class="silk-ribbon"></p>
                
            </div>
            <div class="btn-container flexC">
                <p class="periodValidity" v-if="isExpired">
                    有效期 {{receiveObj.validSt}} 至 {{receiveObj.validEt}}
                </p>
                <div class="btn" :class="{'expiredBtn':!isExpired}" @click="receiveFun">
                    {{isExpired?receiveObj.hasPicked == 0?'立即领取':'立即使用':'无法领取'}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { CouponInfo, couponReceive } from "@/api/user";
export default {
    data () {
        return {
            isExpired:false,
            receiveObj:null,
            couponShareId:this.$route.query.couponShareId,
            couponDefId:this.$route.query.couponDefId,
        }
    },
    created () {
        document.title = "我的优惠券";
        this.getInfoData()
    },
    
    methods: {
        receiveFun(){
            if(!this.isExpired){
                return false;
            }
            if(this.receiveObj.hasPicked == 0){
                const toast = this.$Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: this.$t("message.loadingTxt")
                });
                couponReceive({
                    couponShareId:this.couponShareId,
                    couponDefId:this.couponDefId,
                }).then(result=>{
                    toast.clear();
                    if(result.data.errorCode == 0){
                        // this.getInfoData();
                        this.receiveObj.hasPicked = 1;
                    }else{
                        this.$Toast(result.data.errorMsg)
                    }
                })
            }else{
                this.$router.push({
                    path:"/shop/goods-list",
                })
            }
        },
        getInfoData(){
            const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
            CouponInfo({
                couponShareId:this.couponShareId,
                couponDefId:this.couponDefId,
            }).then(result=>{
                toast.clear();
                if(result.data.errorCode == 0){
                    this.receiveObj = result.data.data;
                    this.isExpired = !(new Date().getTime() > new Date(result.data.data.validEt).getTime()) || (result.data.data.isStopped == 1?false:true);
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.receive-container{
    height: 100%;
    background: url("~@/assets/img/receive-bg.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    .redpacket{
        margin: 1.6rem 0.6rem 0 0.6rem;
        background: url("~@/assets/img/redpacket-bg.png") no-repeat;
        background-size: 100%;
        padding: 3.6rem 0 1.8rem 0;
        .tenant-name{
            text-align: center;
            margin: 0 1.2rem;
            .txt{
                font-size: 0.64rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFDC97;
                line-height: 0.9rem;
                max-width: 80%;
                margin: 0 auto;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .desc{
                font-size: 0.72rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFDC97;
                line-height: 1rem;
            }
        }
        .coupon-info{
            height: 3.8rem;
            background: #fff;
            box-shadow: 0 0.08rem 0.32rem 0 rgba(100,0,0,0.5);
            margin:0.9rem 1.2rem 0 1.2rem;
            .left{
                flex: 0 0 auto;
                width: 3.3rem;
                color: #FF390C;
                justify-content: center;
                font-weight: 600;
                font-family: PingFangSC-Medium, PingFang SC;
                font-size: 1rem;
                .unit{
                    font-size: 0.64rem;
                }
            }
            .line{
                flex: 0 0 auto;
                height: 100%;
                border-left: 1px dashed #979797;
                position: relative;
                &::after,&::before{
                    width: 0.4rem;
                    top: -0.2rem;
                    left: -0.2rem;
                    height: 0.4rem;
                    background: #f34440;
                    position: absolute;
                    border-radius: 50%;
                    content: " ";
                }
                &::before{
                    top: unset;
                    bottom: -0.2rem;
                }
            }
            .silk-ribbon{
                width: 2.44rem;
                margin-right: 0.8rem;
                flex: 0 0 auto;
                height: 100%;
                background: url("~@/assets/img/redpacket-line-icon.png") no-repeat;
                background-size: 100%;
                background-position-y: -0.6rem;
            }
            .right{
                padding: 0 0.6rem;
                flex: 1;
                .coupon-name{
                    font-size: 0.64rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #303133;
                    line-height: 0.9rem;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;				//溢出内容隐藏
                    text-overflow: ellipsis;		//文本溢出部分用省略号表示
                    display: -webkit-box;			//特别显示模式
                    -webkit-line-clamp: 2;			//行数
                    line-clamp: 2;					
                    -webkit-box-orient: vertical;	//盒子中内容竖直排列
                }
                .coupon-desc{
                    font-size: 0.54rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #909399;
                    line-height: 0.8rem;
                }
                
            }
        }
        .btn-container{
            height: 7rem;
            margin-top: -1.1rem;
            position: relative;
            z-index: 1;
            background: url("~@/assets/img/redpacket-bg2.png") no-repeat;
            background-size: 100%;
            flex-direction: column;
            justify-content: flex-end;
            padding-bottom: 1.8rem;
            box-sizing: border-box;
            .btn{
                width: 10.8rem;
                height: 1.88rem;
                line-height: 1.88rem;
                text-align: center;
                background: linear-gradient(180deg, #FBF4CE 0%, #FEDF98 72%, #FFDCA3 100%);
                border-radius: 0.94rem;
                font-size: 0.72rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #974902;
            }
            .periodValidity{
                font-size: 0.48rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFDC97;
                line-height: 0.6rem;
                margin-bottom: 0.66rem;
            }
            .expiredBtn{
                background: #C0C4CC;
                color: #fff;
            }
        }
    }
    .expired-container{
        .coupon-info{
            .left{
                p{
                    color: #909399;
                }
            }
            .right{
                .coupon-name{
                    color: #909399;
                }
            }
            .silk-ribbon{
                background-image: url("~@/assets/img/redpacket-line-icon1.png");
            }
        }
    }
}
</style>